import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CookiesUtil } from '@shared/utils/cookies-util';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs';

@Injectable()
export class CustomHeaderInterceptor implements HttpInterceptor {
  private requestHeader = null;

  constructor(
    protected cookieService: CookieService,
    protected cookiesUtil: CookiesUtil = new CookiesUtil(cookieService)
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.requestHeader) {
      request = request.clone({
        setHeaders: this.requestHeader
      });
    }

    return next.handle(request);
  }
}
